import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SlingConfigService } from 'src/app/services/sling-config.service';
import { ContractLogModalComponent } from '../contract-log-modal/contract-log-modal.component';

@Component({
  selector: 'app-contract-log-table',
  templateUrl: './contract-log-table.component.html',
  styleUrls: ['./contract-log-table.component.scss']
})
export class ContractLogTableComponent implements OnInit {

  @Input() contractLogs = [];

  @Input()
  isDialog = false;

  numberOfRows = 10;

  constructor(
    private slingConfigService: SlingConfigService,
    public dialog: DialogService,
  ) { }

  ngOnInit(): void {
    if ( !this.isDialog) {
      this.loadSlingConfig();
    }
  }

  loadSlingConfig(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (data) => {
        const slingConfig = data[0];
        if (slingConfig != null) {
          this.numberOfRows = slingConfig.numberOfRecordsPerPage;
        } else {
          this.numberOfRows = 10;
        }
      },
      (error) => null);
  }

  openContractLogDialog(contractLog): void {
    this.dialog.open(ContractLogModalComponent, {
      height: '85vh',
      width: '80%',
      dismissableMask: false,
      data: {
        contractLog
      },
      header: 'Log de Contratos'
    })
  }

}
